"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createContact;
function createContact() {
    var fixture = {};

    return {
        setFirstName: function setFirstName(firstName) {
            fixture.firstName = firstName;
            return this;
        },
        setLastName: function setLastName(lastName) {
            fixture.lastName = lastName;
            return this;
        },
        setPhone: function setPhone(phone) {
            fixture.phone = phone;
            return this;
        },
        setEmail: function setEmail(email) {
            fixture.email = email;
            return this;
        },
        val: function val() {
            return fixture;
        }
    };
}